import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { ConfirmModalType, ModalType, TypeOfRates, TypeOfUserView, UpdateModalType, UserStatus } from "../../types/type";

interface ModalState {
    modalUpdate: UpdateModalType;
    modalType: ModalType;
    modalConfirm: ConfirmModalType;
    proposalId: number | null;
    userId: number | null;
    commentId: number | null;
    typeOfStatus: UserStatus | null;
    typeOfRates: TypeOfRates | null;
    typeOfProposalStatus: string | null;
    typeOfUserView: TypeOfUserView | null;
    isPrototype: boolean;
}

const initialState: ModalState = {
    modalUpdate: null,
    modalType: null,
    modalConfirm: null,
    proposalId: null,
    userId: null,
    commentId: null,
    typeOfStatus: null,
    typeOfRates: null,
    typeOfProposalStatus: null,
    typeOfUserView: null,
    isPrototype: false
};

const modalSlice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        setUpdateTypeModal: (state, action: PayloadAction<UpdateModalType>) => {
            state.modalUpdate = action.payload;
        },
        clearUpdateTypeModal: (state) => {
            state.modalUpdate = null
        },
        setTypeModal: (state, action: PayloadAction<ModalType>) => {
            state.modalType = action.payload;
        },
        clearTypeModal: (state) => {
            state.modalType = null
        },

        setTypeOfRates: (state, action: PayloadAction<TypeOfRates>) => {
            state.typeOfRates = action.payload;
        },
        clearTypeOfRates: (state) => {
            state.typeOfRates = null
        },
        
        setProposalId: (state, action: PayloadAction<number | null>) => {
            state.proposalId = action.payload;
        },
        clearProposalId: (state) => {
            state.proposalId = null;
        },
        setUserId: (state, action: PayloadAction<number | null>) => {
            state.userId = action.payload;
        },
        clearUserId: (state) => {
            state.userId = null;
        },
        setConfirmTypeModal: (state, action: PayloadAction<ConfirmModalType>) => {
            state.modalConfirm = action.payload;
        },
        clearConfirmTypeModal: (state) => {
            state.modalConfirm = null
        },
        setTyeOfStatus: (state, action: PayloadAction<'activate' | 'deactivate' | null>) => {
            state.typeOfStatus = action.payload;
        },
        clearTypeOfStatus: (state) => {
            state.typeOfStatus = null
        },
        setTyeOfProposalStatus: (state, action: PayloadAction<string | null>) => {
            state.typeOfProposalStatus = action.payload;
        },
        clearTypeOfProposalStatus: (state) => {
            state.typeOfProposalStatus = null
        },
        setTypeOfUserView: (state, action: PayloadAction<TypeOfUserView>) => {
            state.typeOfUserView = action.payload;
        },
        clearTypeOfUserView: (state) => {
            state.typeOfUserView = null
        },
        setIsPrototype: (state, action: PayloadAction<boolean>) => {
            state.isPrototype = action.payload;
        },
        clearIsPrototype: (state) => {
            state.isPrototype = false;
        },

        setCommentId: (state, action: PayloadAction<number | null>) => {
            state.commentId = action.payload;
        },
        clearCommentId: (state) => {
            state.commentId = null;
        },
    },
});

export const { 
    setUpdateTypeModal,
    clearUpdateTypeModal,

    setTypeModal,
    clearTypeModal,
    
    setProposalId,
    clearProposalId,
    
    setUserId,
    clearUserId,
    
    setConfirmTypeModal,
    clearConfirmTypeModal,
    
    setTyeOfStatus,
    clearTypeOfStatus,
    
    setTyeOfProposalStatus,
    clearTypeOfProposalStatus,
    
    setIsPrototype,
    clearIsPrototype,

    setTypeOfRates,
    clearTypeOfRates,

    setCommentId,
    clearCommentId,

    setTypeOfUserView,
    clearTypeOfUserView,

} = modalSlice.actions;

export const selectCurrentUpdateTypeModal = (state: RootState) => state.modal.modalUpdate;
export const selectCurrentTypeModal = (state: RootState) => state.modal.modalType;
export const selectCurrentConfirmTypeModal = (state: RootState) => state.modal.modalConfirm;
export const selectCurrentProposalId = (state: RootState) => state.modal.proposalId;
export const selectCurrentId = (state: RootState) => state.modal.userId;
export const selectCommentId = (state: RootState) => state.modal.commentId;
export const selectCurrentTypeOfStatus = (state: RootState) => state.modal.typeOfStatus;
export const selectCurrentTypeOfProposalStatus = (state: RootState) => state.modal.typeOfProposalStatus;
export const selectIsPrototype = (state: RootState) => state.modal.isPrototype;
export const selectTypeOfRates = (state: RootState) => state.modal.typeOfRates;
export const selectTypeOfUserView = (state: RootState) => state.modal.typeOfUserView;

export default modalSlice.reducer;